/* eslint-disable */
import Dialog from "@material-ui/core/Dialog";
import { DialogProps } from "@saleor/types";
import React, { useState, useEffect } from "react";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { s3FilesAndImages } from "../queries";
import { useLazyQuery } from "react-apollo";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";

import { useStyles } from "../styles";

export interface S3FilesAndImagesProps extends DialogProps {
  setShowS3Media;
  currentS3Media;
  currentS3MediaType;
  onSelectS3Media;
  defaultCurrentS3Media;
}

const S3FilesAndImagesDialog: React.FC<S3FilesAndImagesProps> = ({
  open,
  onClose,
  setShowS3Media,
  currentS3Media,
  currentS3MediaType,
  onSelectS3Media,
  defaultCurrentS3Media
}) => {
  const classes = useStyles({});
  const [selectS3Media, setSelectS3Media] = useState(currentS3Media);
  const [selectS3MediaType, setSelectS3MediaType] = useState(
    currentS3MediaType
  );

  const getFilePath = url => {
    const path = url
      .replace("https://", "")
      .replace("http://", "")
      .split("/");
    path.shift();
    path.pop();
    return path.join("/");
  };

  const [filePath, setFilePath] = useState(
    currentS3Media ? getFilePath(currentS3Media) : defaultCurrentS3Media
  );

  const filePathList = filePath.split("/");

  const [
    getS3Media,
    { data: s3MediaData, loading: dataLoading }
  ] = useLazyQuery(s3FilesAndImages);

  useEffect(() => {
    if (filePath && filePath !== "") {
      getS3Media({ variables: { filePath: filePath } });
    } else {
      getS3Media();
    }
  }, []);

  // 接口返回的目录不一致，更新当前目录
  useEffect(() => {
    if (s3MediaData) {
      const paths = s3MediaData?.s3FilesAndImages?.filePath.split("/");

      if (paths && filePath.indexOf(paths[0]) === -1) {
        paths.pop();
        const newfilePath = paths.join("/");
        setFilePath(newfilePath);
      }
    }
  }, [filePath, s3MediaData]);

  const GetS3MediaFile = index => {
    const newlist = [];
    for (let i = 0; i <= index; i++) {
      newlist.push(filePathList[i]);
    }
    // console.log(index, newfilePath.join('/'));
    const newfilePath = newlist.join("/");
    getS3Media({ variables: { filePath: newfilePath } });
    setFilePath(newfilePath);
  };

  const openS3MediaFile = file => {
    const newfilePath = filePath + "/" + file;
    getS3Media({ variables: { filePath: newfilePath } });
    setFilePath(newfilePath);
  };

  const selectS3MediaFile = (file, type) => {
    setSelectS3Media(
      s3MediaData?.s3FilesAndImages?.fileHttp + "/" + filePath + "/" + file
    );
    setSelectS3MediaType(type);
  };

  return (
    <Dialog onClose={onClose} maxWidth="md" fullWidth open={open}>
      <DialogTitle className={classes.dtitle}>
        <div className={classes.d12}>
          <p className={classes.f12}>
            {" "}
            当前目录：
            {filePathList.map((item, index) => {
              if (filePathList.length - 1 === index) {
                return <span className={classes.path3}>{item}</span>;
              } else {
                return (
                  <>
                    <span
                      className={classes.path}
                      onClick={() => {
                        GetS3MediaFile(index);
                      }}
                    >
                      {item}
                    </span>
                    <span className={classes.path2}>/</span>
                  </>
                );
              }
            })}
          </p>

          <p className={classes.f12}>选择的素材：{selectS3Media} </p>
        </div>
        <div className={classes.topright}>
          {selectS3MediaType === "image" && (
            <img className={classes.media} src={selectS3Media} />
          )}
          {selectS3MediaType === "video" && (
            <video
              className={classes.media}
              controls
              preload="metadata"
              src={selectS3Media}
            />
          )}
          <div className={classes.topbtn}>
            <button
              className={classes.submit}
              onClick={() => {
                onSelectS3Media(selectS3Media);
                setShowS3Media(false);
              }}
            >
              确定
            </button>
            <button
              className={classes.cancel}
              onClick={() => {
                setShowS3Media(false);
              }}
            >
              取消
            </button>
          </div>
        </div>

        <div
          className={classes.closed}
          onClick={() => {
            setShowS3Media(false);
          }}
        >
          ✕
        </div>
      </DialogTitle>
      <DialogContent className={classes.dcontent}>
        <div className={classes.container}>
          {dataLoading ? (
            <div className={classes.loading}>正在加载中...</div>
          ) : (
            <div className={classes.content}>
              {s3MediaData?.s3FilesAndImages?.subFile?.map((item, index) => {
                const url =
                  s3MediaData?.s3FilesAndImages?.fileHttp +
                  "/" +
                  s3MediaData?.s3FilesAndImages?.filePath +
                  item.fileName;

                if (item.fileType === "image") {
                  return (
                    <div
                      className={classes.item}
                      key={index}
                      onClick={() => {
                        selectS3MediaFile(item.fileName, item.fileType);
                      }}
                    >
                      <img height="100" src={url} />
                      <p>{item.fileName}</p>
                    </div>
                  );
                } else if (item.fileType === "video") {
                  return (
                    <div
                      className={classes.item}
                      key={index}
                      onClick={() => {
                        selectS3MediaFile(item.fileName, item.fileType);
                      }}
                    >
                      <video height="100" controls src={url} />{" "}
                      <p>{item.fileName}</p>
                    </div>
                  );
                } else if (item.fileType === "folder") {
                  return (
                    <div
                      className={classes.item}
                      key={index}
                      onClick={() => {
                        openS3MediaFile(item.fileName);
                      }}
                    >
                      <FolderOpenRoundedIcon />
                      <p>{item.fileName}</p>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
S3FilesAndImagesDialog.displayName = "S3FilesAndImagesDialog";
export default S3FilesAndImagesDialog;
